<script>
import { createWidgetMixin } from 'vue-instantsearch/vue3/es';
import { connectHits } from 'instantsearch.js/es/connectors';
import Spinner from '@/components/helpers/Spinner.vue'

export default {
  name: "AlgoliaLoading",
  components: { Spinner },
  mixins: [createWidgetMixin({ connector: connectHits })],
  computed: {
    searchIsLoading() {
      return !this?.state
    },
  }
};
</script>

<template>
  <div v-if="searchIsLoading" class="relative h-50-screen">
    <Spinner/>
  </div>
</template>
